export const OrganisationSlug = {
  ncte: { slug: "national-council-for-teacher-education", id: 14 },
}
